// this file is generated by update_shopify_store_data.py at 2026-06-22 20:28:09.930692
var courses = [
    {
        "course_id": "A1077672-4B86-EE11-9987-005056A725AD",
        "course_version": 1,
        "name": "ANA: APRN Pharmacology Today: Polypharmacy Considerations",
        "course_type": 1,
        "author_information": "",
        "description": "Overview\r\n\r\nThis course offers the APRN an overview of polypharmacy, the concerns related to polypharmacy, and how to address the overall impact of polypharmacy, especially when considering the older adult and geriatric populations. This course assists the APRN in fulfilling pharmacology CE requirements for licensure.",
        "learning_objectives_html": "At the conclusion, participants should be able to:\r\n<ul>\r\n    <li>Describe polypharmacy and the impact of polypharmacy on older adults</li>\r\n    <li>Discuss key aspects of BEERS criteria and application to practice</li>\r\n    <li>Explore different tools and resources do decrease inappropriate medication prescribing</li>\r\n    <li>Identify one practice change based on current course content</li>\r\n</ul>",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "C98E2D7E-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Anesthetist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "41A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Pharmacology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "18DBACB6-C884-EE11-998F-005056A7C6AF",
                "course_category_name": "ANA - American Nurses Association",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8FAC2CA7-C884-EE11-998F-005056A7C6AF",
                "course_category_name": "ANA - American Nurses Association",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5EC7EE02-0083-EE11-9986-005056A740BF",
                "course_category_name": "ANA - American Nurses Association",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9D089F81-80D3-EF11-9991-005056A78EAA",
                "course_category_name": "ANA - ANA APRN Pharmacology Bundle - Courses",
                "is_system_course_category": null
            },
            {
                "course_category_id": "02064EC2-15DD-E311-AD18-005056B141CC",
                "course_category_name": "Medications",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                "course_category_name": "Nurse Practitioner",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "American Nurses Association is accredited with distinction as a provider of nursing continuing professional development by the American Nurses Credentialing Center's Commission on Accreditation.",
            "course_level_accreditation_statement": "",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 3.6,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    }
];